const taxData = {
  year: 2017,
  deferralLimit: 18000,
  interestRate: 6.5,
  accumulationPeriods: [0, 10, 20, 30],
  payPeriods: [
    {
      uid: 'daily',
      allowanceLimit: 15.6,
      single: [
        { over: 0, under: 8.8, base: 0, percent: 0 },
        { over: 8.8, under: 44.7, base: 0, percent: 10 },
        { over: 44.7, under: 154.8, base: 3.59, percent: 15 },
        { over: 154.8, under: 362.3, base: 20.11, percent: 25 },
        { over: 362.3, under: 746.0, base: 71.99, percent: 28 },
        { over: 746.0, under: 1611.5, base: 179.43, percent: 33 },
        { over: 1611.5, under: 1618.1, base: 465.05, percent: 35 },
        { over: 1618.1, under: Infinity, base: 467.36, percent: 39.6 },
      ],
      married: [
        { over: 0, under: 33.3, base: 0, percent: 0 },
        { over: 33.3, under: 105.0, base: 0, percent: 10 },
        { over: 105.0, under: 325.2, base: 7.17, percent: 15 },
        { over: 325.2, under: 622.1, base: 40.2, percent: 25 },
        { over: 622.1, under: 930.8, base: 114.43, percent: 28 },
        { over: 930.8, under: 1636.0, base: 200.87, percent: 33 },
        { over: 1636.0, under: 1843.7, base: 433.59, percent: 35 },
        { over: 1843.7, under: Infinity, base: 506.29, percent: 39.6 },
      ],
    },
    {
      uid: 'weekly',
      allowanceLimit: 77.9,
      single: [
        { over: 0, under: 44, base: 0, percent: 0 },
        { over: 44, under: 224, base: 0, percent: 10 },
        { over: 224, under: 774, base: 18, percent: 15 },
        { over: 774, under: 1812, base: 100.5, percent: 25 },
        { over: 1812, under: 3730, base: 360, percent: 28 },
        { over: 3730, under: 8058, base: 897.04, percent: 33 },
        { over: 8058, under: 8090, base: 2325.28, percent: 35 },
        { over: 8090, under: Infinity, base: 2336.48, percent: 39.6 },
      ],
      married: [
        { over: 0, under: 166, base: 0, percent: 0 },
        { over: 166, under: 525, base: 0, percent: 10 },
        { over: 525, under: 1626, base: 35.9, percent: 15 },
        { over: 1626, under: 3111, base: 201.05, percent: 25 },
        { over: 3111, under: 4654, base: 572.3, percent: 28 },
        { over: 4654, under: 8180, base: 1004.34, percent: 33 },
        { over: 8180, under: 9218, base: 2167.92, percent: 35 },
        { over: 9218, under: Infinity, base: 2531.22, percent: 39.6 },
      ],
    },
    {
      uid: 'biweekly',
      allowanceLimit: 155.8,
      single: [
        { over: 0, under: 88, base: 0, percent: 0 },
        { over: 88, under: 447, base: 0, percent: 10 },
        { over: 447, under: 1548, base: 35.9, percent: 15 },
        { over: 1548, under: 3623, base: 201.05, percent: 25 },
        { over: 3623, under: 7460, base: 719.8, percent: 28 },
        { over: 7460, under: 16115, base: 1794.16, percent: 33 },
        { over: 16115, under: 16181, base: 4650.31, percent: 35 },
        { over: 16181, under: Infinity, base: 4673.41, percent: 39.6 },
      ],
      married: [
        { over: 0, under: 333, base: 0, percent: 0 },
        { over: 333, under: 1050, base: 0, percent: 10 },
        { over: 1050, under: 3252, base: 71.7, percent: 15 },
        { over: 3252, under: 6221, base: 402, percent: 25 },
        { over: 6221, under: 9308, base: 1144.25, percent: 28 },
        { over: 9308, under: 16360, base: 2008.61, percent: 33 },
        { over: 16360, under: 18437, base: 4335.77, percent: 35 },
        { over: 18437, under: Infinity, base: 5062.72, percent: 39.6 },
      ],
    },
    {
      uid: 'semimonthly',
      allowanceLimit: 168.8,
      single: [
        { over: 0, under: 96, base: 0, percent: 0 },
        { over: 96, under: 484, base: 0, percent: 10 },
        { over: 484, under: 1677, base: 38.8, percent: 15 },
        { over: 1677, under: 3925, base: 217.75, percent: 25 },
        { over: 3925, under: 8081, base: 779.75, percent: 28 },
        { over: 8081, under: 17458, base: 1943.43, percent: 33 },
        { over: 17458, under: 17529, base: 5037.84, percent: 35 },
        { over: 17529, under: Infinity, base: 5062.69, percent: 39.6 },
      ],
      married: [
        { over: 0, under: 360, base: 0, percent: 0 },
        { over: 360, under: 1138, base: 0, percent: 10 },
        { over: 1138, under: 3523, base: 77.8, percent: 15 },
        { over: 3523, under: 6740, base: 435.55, percent: 25 },
        { over: 6740, under: 10083, base: 1239.8, percent: 28 },
        { over: 10083, under: 17723, base: 2175.84, percent: 33 },
        { over: 17723, under: 19973, base: 4697.04, percent: 35 },
        { over: 19973, under: Infinity, base: 5484.54, percent: 39.6 },
      ],
    },
    {
      uid: 'monthly',
      allowanceLimit: 337.5,
      single: [
        { over: 0, under: 192, base: 0, percent: 0 },
        { over: 192, under: 969, base: 0, percent: 10 },
        { over: 969, under: 3354, base: 77.7, percent: 15 },
        { over: 3354, under: 7850, base: 435.45, percent: 25 },
        { over: 7850, under: 16163, base: 1559.45, percent: 28 },
        { over: 16163, under: 34917, base: 3887.09, percent: 33 },
        { over: 34917, under: 35058, base: 10075.91, percent: 35 },
        { over: 35058, under: Infinity, base: 10125.26, percent: 39.6 },
      ],
      married: [
        { over: 0, under: 721, base: 0, percent: 0 },
        { over: 721, under: 2275, base: 0, percent: 10 },
        { over: 2275, under: 7046, base: 155.4, percent: 15 },
        { over: 7046, under: 13479, base: 871.05, percent: 25 },
        { over: 13479, under: 20167, base: 2479.3, percent: 28 },
        { over: 20167, under: 35446, base: 4351.94, percent: 33 },
        { over: 35446, under: 39946, base: 9394.01, percent: 35 },
        { over: 39946, under: Infinity, base: 10969.01, percent: 39.6 },
      ],
    },
    {
      uid: 'quarterly',
      allowanceLimit: 1012.5,
      single: [
        { over: 0, under: 575, base: 0, percent: 0 },
        { over: 575, under: 2906, base: 0, percent: 10 },
        { over: 2906, under: 10063, base: 233.1, percent: 15 },
        { over: 10063, under: 23550, base: 1306.65, percent: 25 },
        { over: 23550, under: 48488, base: 4678.4, percent: 28 },
        { over: 48488, under: 104750, base: 11661.04, percent: 33 },
        { over: 104750, under: 105175, base: 30227.5, percent: 35 },
        { over: 105175, under: Infinity, base: 30376.25, percent: 39.6 },
      ],
      married: [
        { over: 0, under: 2163, base: 0, percent: 0 },
        { over: 2163, under: 6825, base: 0, percent: 10 },
        { over: 6825, under: 21138, base: 466.2, percent: 15 },
        { over: 21138, under: 40438, base: 2613.15, percent: 25 },
        { over: 40438, under: 60500, base: 7438.15, percent: 28 },
        { over: 60500, under: 106338, base: 13055.51, percent: 33 },
        { over: 106338, under: 119838, base: 28182.05, percent: 35 },
        { over: 119838, under: Infinity, base: 32907.05, percent: 39.6 },
      ],
    },
    {
      uid: 'semiannual',
      allowanceLimit: 2025,
      single: [
        { over: 0, under: 1150, base: 0, percent: 0 },
        { over: 1150, under: 5813, base: 0, percent: 10 },
        { over: 5813, under: 20125, base: 466.3, percent: 15 },
        { over: 20125, under: 47100, base: 2613.1, percent: 25 },
        { over: 47100, under: 96975, base: 9356.85, percent: 28 },
        { over: 96975, under: 209500, base: 23321.85, percent: 33 },
        { over: 209500, under: 210350, base: 60455.1, percent: 35 },
        { over: 210350, under: Infinity, base: 60752.6, percent: 39.6 },
      ],
      married: [
        { over: 0, under: 4325, base: 0, percent: 0 },
        { over: 4325, under: 13650, base: 0, percent: 10 },
        { over: 13650, under: 42275, base: 932.5, percent: 15 },
        { over: 42275, under: 80875, base: 5226.25, percent: 25 },
        { over: 80875, under: 121000, base: 14876.25, percent: 28 },
        { over: 121000, under: 212675, base: 26111.25, percent: 33 },
        { over: 212675, under: 239675, base: 56364, percent: 35 },
        { over: 239675, under: Infinity, base: 65814, percent: 39.6 },
      ],
    },
    {
      uid: 'annual',
      allowanceLimit: 4050,
      single: [
        { over: 0, under: 2300, base: 0, percent: 0 },
        { over: 2300, under: 11625, base: 0, percent: 10 },
        { over: 11625, under: 40250, base: 932.5, percent: 15 },
        { over: 40250, under: 94200, base: 5226.25, percent: 25 },
        { over: 94200, under: 193950, base: 18713.75, percent: 28 },
        { over: 193950, under: 419000, base: 46643.75, percent: 33 },
        { over: 419000, under: 420700, base: 120910.25, percent: 35 },
        { over: 420700, under: Infinity, base: 121505.25, percent: 39.6 },
      ],
      married: [
        { over: 0, under: 8650, base: 0, percent: 0 },
        { over: 8650, under: 27300, base: 0, percent: 10 },
        { over: 27300, under: 84550, base: 1865, percent: 15 },
        { over: 84550, under: 161750, base: 10452.5, percent: 25 },
        { over: 161750, under: 242000, base: 29752.5, percent: 28 },
        { over: 242000, under: 425350, base: 52222.5, percent: 33 },
        { over: 425350, under: 479350, base: 112728, percent: 35 },
        { over: 479350, under: Infinity, base: 131628, percent: 39.6 },
      ],
    },
  ],
};

export default taxData;



// WEBPACK FOOTER //
// ./src/config/taxData.js